import "./App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Landing from "./pages/Landing";
import ProjectPage from "./pages/ProjectPage";

function App() {
  useEffect(() => {
    const blockContext = (e) => {
      // allow context menu inside form fields
      const t = e.target;
      if (t && (t.tagName === "INPUT" || t.tagName === "TEXTAREA")) return;
      e.preventDefault();
    };
    const blockDrag = (e) => {
      const t = e.target;
      if (t && (t.tagName === "IMG" || t.tagName === "VIDEO" || t.tagName === "CANVAS" || t.tagName === "SVG")) {
        e.preventDefault();
      }
    };
    const blockKeys = (e) => {
      const t = e.target;
      const inField = t && (t.tagName === "INPUT" || t.tagName === "TEXTAREA" || t.isContentEditable);
      const key = e.key ? e.key.toLowerCase() : "";
      // Block save, print, copy, cut, view-source, select-all, devtools outside form fields
      if ((e.ctrlKey || e.metaKey) && ["s", "p", "u"].includes(key)) {
        e.preventDefault();
        return;
      }
      if (!inField && (e.ctrlKey || e.metaKey) && ["c", "x", "a"].includes(key)) {
        e.preventDefault();
        return;
      }
      // F12 / Ctrl+Shift+I|J|C devtools deterrent
      if (key === "f12" || ((e.ctrlKey || e.metaKey) && e.shiftKey && ["i", "j", "c"].includes(key))) {
        e.preventDefault();
      }
    };
    const blockCopy = (e) => {
      const t = e.target;
      if (t && (t.tagName === "INPUT" || t.tagName === "TEXTAREA" || t.isContentEditable)) return;
      e.preventDefault();
    };

    document.addEventListener("contextmenu", blockContext);
    document.addEventListener("dragstart", blockDrag);
    document.addEventListener("keydown", blockKeys);
    document.addEventListener("copy", blockCopy);
    document.addEventListener("cut", blockCopy);

    return () => {
      document.removeEventListener("contextmenu", blockContext);
      document.removeEventListener("dragstart", blockDrag);
      document.removeEventListener("keydown", blockKeys);
      document.removeEventListener("copy", blockCopy);
      document.removeEventListener("cut", blockCopy);
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/work/:slug" element={<ProjectPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
